import styles from '@components/components/HeatPumpRecommender/HeatPumpRecommender.module.scss';
import AddressPicker, {
  defaultValues,
} from '@components/components/AddressPicker/AddressPicker';
import {
  trackInteraction,
  useLocalStorage,
  useTracking,
} from '@components/hooks';
import React, { useState } from 'react';
import {
  Button,
  Card,
  Content,
  FontAwesomeProIcon,
  Heading,
} from '@wienenergiegithub/ui-next';
import { defaultValuesAddressPicker } from '../AddressPicker/AddressPicker.config';

export const STEPS = {
  CHECK_AVAILABILITY: 'CHECK_AVAILABILITY',
  UNAVAILABLE: 'UNAVAILABLE',
};

const UnAvailable = ({ handleReset }) => {
  const [storage] = useLocalStorage('address-check');

  return (
    <div
      className={styles.availableContainer}
      data-purpose="waermepumpe-available"
    >
      <div className={styles.timesIcon}>
        <FontAwesomeProIcon icon="times" size="lg" />
      </div>
      <Heading className={styles.heading} size="h6">
        Für diese Adresse gibt es leider noch kein Wärmepumpen-Angebot:
      </Heading>
      <Content noSpacing>
        {storage?.strasse} {`${storage?.gebadr1}`}
        {storage?.tuerNr && `/${storage?.tuerNr}`}, {storage?.plzOrt}
      </Content>
      <Button
        className={styles.newCheckButton}
        id="waermepumpe-weitere-addresse-pruefen"
        onClick={handleReset}
        theme="tertiary"
        variant="link"
      >
        Andere ADRESSE PRÜFEN
      </Button>
    </div>
  );
};

const HeatPumpRecommender = ({ onUnavailable, signUpLink, addresses }) => {
  const [storage, setStorage] = useLocalStorage('address-check');
  const [step, setStep] = useState(STEPS.CHECK_AVAILABILITY);
  const track = useTracking();
  const inNewTab = signUpLink?.target === '_blank';

  const signUpUrl = React.useMemo(() => {
    const url = new URL(signUpLink?.url);
    return url.toString();
  }, [signUpLink, storage]);

  const handleOnUnavailable = (...args) => {
    onUnavailable(...args);
    setStep(STEPS.UNAVAILABLE);
  };

  const toHeatPumpPage = () => {
    if (inNewTab) {
      window.open(signUpUrl, '_blank');
    } else {
      window.location.href = signUpUrl;
    }
  };

  const handleOnSuccess = postValues => {
    if (!postValues) {
      return;
    }

    track({
      event: 'waermepumpe',
      eventCategory: 'waermepumpe',
      eventAction: 'angefragt',
      eventName: postValues.plz,
    });

    const isAvailable = addresses.includes(postValues.plz);

    setStorage({
      ...storage,
      heatpumpAvalabilitiy: isAvailable ? 'JA' : 'NEIN',
    });

    if (isAvailable) {
      track({
        event: 'waermepumpe',
        eventCategory: 'waermepumpe',
        eventAction: 'verfuegbar',
        eventName: postValues.plz,
      });
      toHeatPumpPage();
    } else {
      track({
        event: 'waermepumpe',
        eventCategory: 'waermepumpe',
        eventAction: 'nicht-verfuegbar',
        eventName: postValues.plz,
      });
      handleOnUnavailable();
    }
  };

  const handleOnError = error => {
    if (error?.response) {
      // eslint-disable-next-line no-console
      console.log(error?.response);
    }
  };

  const handleNewCheck = () => {
    trackInteraction('Wärmepumpe;Auswahl;Adresse;Andere Adresse prüfen');
    setStorage(defaultValuesAddressPicker);
    setStep(STEPS.CHECK_AVAILABILITY);
  };

  return (
    <Card className={styles.container}>
      <div className={styles.disclosure}>
        <div className={styles.headingGroup}>
          <FontAwesomeProIcon
            className={styles.icon}
            icon="home-lg-alt"
            size="lg"
          />
          <Heading as="span" noSpacing size="h6" theme="neutral">
            Wärmepumpen-Rechner
          </Heading>
        </div>
      </div>
      <div className={styles.content}>
        {step === STEPS.CHECK_AVAILABILITY && (
          <AddressPicker
            buttonId="waermepumpen-ueberpruefen"
            heatPumpRecommender
            onError={handleOnError}
            onSuccess={handleOnSuccess}
            subtitle="Welche Wärmepumpe passt für Ihr neu zu errichtendes Haus? Bitte zuerst die Adresse angeben:"
            type="heatPump"
          />
        )}
        {step === STEPS.UNAVAILABLE && (
          <UnAvailable handleReset={handleNewCheck} />
        )}
      </div>
    </Card>
  );
};

HeatPumpRecommender.defaultProps = {
  onUnavailable: () => {},
};

export default HeatPumpRecommender;
